import appLocaleData from 'react-intl/locale-data/zh';
import chMessages from '../locales/zh-ZH';

const ChLang = {
    messages: {
        ...chMessages
    },
    locale: 'zh-ZH',
    data: appLocaleData
};
export default ChLang;